export enum UserRegistrationStep {
  PENDING_EMAIL_VERIFICATION = 'pending_email_verification',
  PENDING_MOBILE = 'pending_mobile',
  PENDING_MOBILE_VERIFICATION = 'pending_mobile_verification',
  PENDING_PROFILE = 'pending_profile',
  PENDING_USER_CONVERTION = 'pending_user_convertion',
  COMPLETED = 'completed',
}

export type UserRegistrationStepToDo = Exclude<UserRegistrationStep, UserRegistrationStep.COMPLETED>;
